// sulfadimethoxine-calculator-page.ts
import Alpine from 'alpinejs';
import "../store/email-capture"
import '../components/sulfadimethoxine-calculator';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

Alpine.start();
